/*
## Part-numbers ##

- Cloud Pak parts:
D05SSZX = EPS Usage based Cloud Pak parts for QRoC (520)
D05STZX = FPM Usage based Cloud Pak parts for QRoC (260)

- Additional Cloud Pak parts for OnPrem
D05M5ZX = [RU Monthly Sub List Price] (150)
*/

// Monthly EPS prices per part
export const EPS_PRICES = [520, 130]; // [100 EPS Rate 1-10, 100 EPS Rate 11-50] > D05SSZX

// Quantities per tier (EPS)
export const EPS_QTY = [4, 10, 50];

// Monthly FPM prices per part
export const FPM_PRICES = [260, 182]; // [10K FPM Rate 1-10, 10K FPM Rate 11-40] > D05STZX

// Quantities per tier (FPM)
export const FPM_QTY = [0, 10, 40];

// onPrem => [RU Monthly Sub List Price]
export const RU_MONTHLY_SUBLIST_PRICE = 150; // > D05M5ZX
